import { Button, Grid, IconButton } from "@mui/material";
import { memo } from "react";
import { Instance as TinyColor } from 'tinycolor2'
import ColorSwatch from "../colorSwatch/colorSwatch";
import PlusIcon from "../../../assets/icons/PlusIcon";
import useStyles from './styles'

export type RecentSwatchesProps = {
    value: TinyColor,
    swatches: TinyColor[],
    onColorSelect: (value: TinyColor) => void,
    onNewSwatchAdded: (value: TinyColor) => void,
    onAddNewClick: () => void
}

const RecentSwatches: React.FC<RecentSwatchesProps> = ({value, swatches, onColorSelect, onAddNewClick}) => {
    const { classes } = useStyles();
    return (
        <Grid gap={0.5} flexDirection='row' display='flex' flexWrap='wrap' justifyContent='flex-start'>
            {swatches.map((sw, i) => <ColorSwatch key={sw.toHex8String()} value={sw} onClick={onColorSelect} selected={value.toHexString() === sw.toHexString()}/>)}
            <IconButton className={classes.addSwatchButton} onClick={onAddNewClick}><PlusIcon /></IconButton>
        </Grid>
    );
}


export default memo(RecentSwatches)